<div *ngIf="postedAircraftTripSkeletonsLoading$ | async">Loading...</div>
<div *ngIf="postedAircraftTripSkeletonsLoaded$ | async">
  <div *ngIf="postedAircraftTripSkeletons$ | async as postedAircraftTripSkeletons">
    <div *ngIf="postedAircraftTripSkeletons.length > 0; else noPostedAircraftTrips">
      <mat-accordion>
        <sd-portal-trip-manager-trip-audit
          *ngFor="let postedAircraftTripSkeleton of postedAircraftTripSkeletons$ | async"
          [postedAircraftTripSkeleton]="postedAircraftTripSkeleton"
          [postedAircraftTripAuditLoading]="postedAircraftTripAuditLoading$ | async"
          [postedAircraftTripAuditLoaded]="postedAircraftTripAuditLoaded$ | async"
          [postedAircraftTripAudit]="postedAircraftTripAudit$ | async"
          [postedAircraftTripLegAuditLoading]="postedAircraftTripLegAuditLoading$ | async"
          [postedAircraftTripLegAuditLoaded]="postedAircraftTripLegAuditLoaded$ | async"
          [postedAircraftTripLegAudit]="postedAircraftTripLegAudit$ | async"
          (onOpened)="tripManagerFacade.loadPostedAircraftTripAudit($event)"
          (onNextPage)="tripManagerFacade.nextPostedAircraftTripAuditPage($event)"
          (onLegOpened)="tripManagerFacade.loadPostedAircraftTripLegAudit($event)"
          (onLegNextPage)="tripManagerFacade.nextPostedAircraftTripLegAuditPage($event)"
        ></sd-portal-trip-manager-trip-audit>
      </mat-accordion>
    </div>

    <ng-template #noPostedAircraftTrips> No trips to audit </ng-template>
  </div>
</div>
